import type { Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import { api } from "../../../api/client";
import { loadInboxStructure } from "../inboxStructure/thunks";
import { MessageActions } from "./actions";
import type { MessagesPayload } from "./reducer";
import type { MessageLoadingState } from "./types";
import { FilterConfigurationLoadingState } from "./types";

type MessagesDispatch = Dispatch<PayloadAction<MessagesPayload>>;

const markManyAsImportant = withErrorHandling(api.messages.markManyAsImportant);
const getFilterConfiguration = withErrorHandling(api.messages.loadFilterConfiguration);

const loadInboxStructureAsync = loadInboxStructure();

export function markAsImportant(messageIds: string[], value: boolean) {
  return async (dispatch: MessagesDispatch) => {
    dispatch(MessageActions.UpdateLoading({ markAsImportantUpdating: true } as MessageLoadingState));

    const [resp, error] = await markManyAsImportant(messageIds, value);
    if (error) {
      logError(error, "[markAsImportant]");
    } else if (resp.updates) {
      resp.updates.forEach((update) => {
        dispatch(MessageActions.MarkAsImportant(update.messageId, update.markAsImportant));
      });

      await loadInboxStructureAsync(dispatch);
    }

    dispatch(MessageActions.UpdateLoading({ markAsImportantUpdating: false } as MessageLoadingState));
  };
}

export function loadConfiguration() {
  return async (dispatch: MessagesDispatch) => {
    dispatch(
      MessageActions.UpdateLoading({
        filterConfiguration: FilterConfigurationLoadingState.Loading,
      } as MessageLoadingState)
    );

    let loadingState: FilterConfigurationLoadingState;

    const [filterConfiguration, error] = await getFilterConfiguration();
    if (error) {
      logError(error, "[loadFilterConfiguration]");
      loadingState = FilterConfigurationLoadingState.Error;
    } else {
      dispatch(MessageActions.UpdateState({ filterConfiguration }));
      loadingState = FilterConfigurationLoadingState.Loaded;
    }

    dispatch(MessageActions.UpdateLoading({ filterConfiguration: loadingState } as MessageLoadingState));
  };
}
